const prod = {
  url: {
    API_URL: "https://gmg-api.qatrace.com/api/",
    STORAGE_URL: "https://gmg-api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8000/api/",
    STORAGE_URL: "http://localhost:8000/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
